import { render, staticRenderFns } from "./btn-top-primary.vue?vue&type=template&id=fe968af8&scoped=true&"
import script from "./btn-top-primary.vue?vue&type=script&lang=js&"
export * from "./btn-top-primary.vue?vue&type=script&lang=js&"
import style0 from "./btn-top-primary.vue?vue&type=style&index=0&id=fe968af8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe968af8",
  null
  
)

export default component.exports